//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';

import * as galleriesApi from '@apis/galleries/galleriesApi';

import { GetNgApiAdapterType, createNgApiAdapterService } from 'app/angular-apis/createNgApiAdapter';

// TODO: add more of the Galleries apis

const galleriesApiService = createNgApiAdapterService(galleriesApi);
export type GalleriesApiService = GetNgApiAdapterType<typeof galleriesApiService>;

angular.module('curalate').service('GalleriesApi', galleriesApiService);
